// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"j3-z","subtitle":"k3-z","wrapper":"l3-z","leftArrow":"m3-z","rightArrow":"n3-z"};